import React, { useState } from 'react';
import CrmCompanyFields, { unitName, portfolioSellerNames } from './CrmCompanyFields';
import { crmRequest } from './crmApi';

export default function CompanyPortfolioEditor({ company, metadata, onSaved }) {
    const [draft, setDraft] = useState(null);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const canEdit = metadata.canManageAssignments && !company.readOnly;
    async function save() {
        if (busy) return;
        setBusy(true); setError('');
        try {
            const updated = await crmRequest(`/companies/${company._id}/portfolios`, 'patch', { portfolios: draft.portfolios, revision: draft.revision });
            setDraft(null); onSaved(updated);
        } catch (e) { setError(e.message); }
        finally { setBusy(false); }
    }
    return <div className="client-portfolio-editor">
        {draft && canEdit ? <>
            <fieldset disabled={busy} className="client-portfolio-controls">
                <CrmCompanyFields draft={draft} setDraft={setDraft} metadata={metadata} editing showType={false} disabled={busy} />
            </fieldset>
            {error && <p role="alert" className="crm-error">{error}</p>}
            <div className="client-portfolio-actions">
                <button type="button" disabled={busy} onClick={save}>{busy ? 'Guardando…' : 'Guardar asignación'}</button>
                <button type="button" disabled={busy} onClick={() => { setDraft(null); setError(''); }}>Cancelar</button>
            </div>
        </> : <>
            {company.portfolios?.length ? company.portfolios.map(p => <div key={p.businessUnit}>{unitName(p.businessUnit)} · {portfolioSellerNames(p, metadata)}</div>) : 'Admin · pendiente de asignación'}
            {canEdit && <button type="button" className="client-text-button" onClick={() => { setError(''); setDraft({ portfolios: company.portfolios || [], revision: company.revision || 0 }); }}>Editar unidad / vendedores</button>}
        </>}
    </div>;
}
